import React from "react";

import dayjs from "dayjs";

import {
  Tag,
  Tooltip,
  Typography,
} from "components/Common/clearsense-ui/components";
import { getTimeAndDate } from "utils/date";
import { humanize } from "utils/stringManipulations";

import { getStatusColor } from "../../../../utils";

export const COLUMN_DATA = [
  {
    dataIndex: "name",
    key: "name",
    title: "Name",
  },
  {
    dataIndex: "runDate",
    key: "runDate",
    align: "center",
    title: "Run Date",
    render: (_, { runDate }) => {
      if (!runDate) return "Not available";
      const convertedDate = dayjs.unix(runDate);
      const { date, time } = getTimeAndDate(convertedDate);

      return (
        <Tooltip content={`${date} ${time}`} position="bottom">
          <Typography>{convertedDate.fromNow()}</Typography>
        </Tooltip>
      );
    },
  },
  {
    dataIndex: "status",
    key: "status",
    title: "Status",
    align: "center",
    render: (_, { status }) => (
      <Tag color={getStatusColor(status)} label={humanize(status)} />
    ),
  },
];
